import React, { useState } from "react";
import { Card, CardBody, Badge, Progress } from "reactstrap";
import { formatCurrency } from "../utils/dreCalculations";
import { MONTH_LABELS } from "../constants";

/**
 * DRETable Refatorado
 * Agora espelha fielmente a matemática Contábil Pura.
 * Custo de gateways já estão internalizados no "Despesas e Custos".
 */
const DRETable = ({ dreData, year, month }) => {
    const { income, expense, totals } = dreData;
    const [expandedIncome, setExpandedIncome] = useState(true);
    const [expandedExpense, setExpandedExpense] = useState(true);

    const monthLabel = MONTH_LABELS[(month || 1) - 1];
    const resultIsPositive = totals.netResult >= 0;

    return (
        <Card 
            className="neo-stat-card mt-2"
            style={{
                background: "#fff",
                borderRadius: "16px",
                border: "2px solid #482712",
                boxShadow: "0 15px 40px rgba(72, 39, 18, 0.08)",
                overflow: "hidden"
            }}
        >
            <CardBody className="p-0">

                {/* Título do card com ícone outonado */}
                <div className="d-flex align-items-center gap-3 px-4 pt-4 pb-3" style={{ borderBottom: "2px solid rgba(72, 39, 18, 0.12)" }}>
                    <div 
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{
                            width: "36px",
                            height: "36px",
                            background: "rgba(226, 102, 28, 0.08)",
                            border: "1px solid rgba(226, 102, 28, 0.20)"
                        }}
                    >
                        <i className="mdi mdi-finance font-size-18" style={{ color: "#e2661c" }} />
                    </div>
                    <h5 className="mb-0 fw-bold text-uppercase text-dark" style={{ fontFamily: "Outfit, sans-serif", fontSize: "1.05rem", fontWeight: 900 }}>
                        DRE Contábil – {monthLabel} / {year}
                    </h5>
                </div>

                {/* Cabeçalho da tabela */}
                <div
                    className="d-flex align-items-center px-4 py-2.5"
                    style={{ background: "var(--color-bg-canvas)", borderBottom: "2px solid rgba(72, 39, 18, 0.12)" }}
                >
                    <div style={{ flex: 1 }}>
                        <span style={{ fontSize: "0.75rem", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.5px", color: "var(--color-brand-secondary)", fontFamily: "Outfit, sans-serif" }}>
                            Categoria
                        </span>
                    </div>
                    <div style={{ width: "30%", textAlign: "center" }}>
                        <span style={{ fontSize: "0.75rem", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.5px", color: "var(--color-brand-secondary)", fontFamily: "Outfit, sans-serif" }}>
                            Percentual
                        </span>
                    </div>
                    <div style={{ width: "160px", textAlign: "right" }}>
                        <span style={{ fontSize: "0.75rem", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.5px", color: "var(--color-brand-secondary)", fontFamily: "Outfit, sans-serif" }}>
                            Valor Base
                        </span>
                    </div>
                </div>

                {/* ═══ RECEITAS OPERACIONAIS ═══ */}
                <div
                    className="d-flex align-items-center px-4 py-3"
                    style={{ cursor: "pointer", borderBottom: "1px solid rgba(72, 39, 18, 0.08)", background: "rgba(40, 167, 69, 0.02)", transition: "background-color 0.2s" }}
                    onClick={() => setExpandedIncome(!expandedIncome)}
                >
                    <div style={{ flex: 1, display: "flex", alignItems: "center", gap: "8px" }}>
                        <i
                            className={`mdi mdi-plus-circle${expandedIncome ? "-outline" : ""}`}
                            style={{ color: "#2e7d32", fontSize: "1.1rem" }}
                        />
                        <span className="fw-bold text-uppercase" style={{ color: "#2e7d32", fontSize: "0.85rem", letterSpacing: "0.5px", fontFamily: "Outfit, sans-serif" }}>
                            Receitas (Competência Total)
                        </span>
                    </div>
                    <div style={{ width: "30%" }} />
                    <div style={{ width: "160px" }} />
                </div>

                {expandedIncome && income.map((line) => {
                    const pct = totals.totalIncome > 0 ? (line.amount / totals.totalIncome * 100) : 0;
                    return (
                        <div
                            key={line.id}
                            className="d-flex align-items-center px-4 py-2.5"
                            style={{ borderBottom: "1px solid rgba(72, 39, 18, 0.06)", paddingLeft: "48px" }}
                        >
                            <div style={{ flex: 1, paddingLeft: "28px" }}>
                                <span style={{ fontSize: "0.85rem", color: "var(--color-brand-primary)", fontFamily: "Outfit, sans-serif", fontWeight: 600 }}>
                                    {line.name}
                                </span>
                            </div>
                            <div style={{ width: "30%", display: "flex", alignItems: "center", gap: "8px", justifyContent: "center" }}>
                                <span style={{ fontSize: "0.75rem", color: "#78909c", minWidth: "40px", textAlign: "right" }}>
                                    {pct.toFixed(1)}%
                                </span>
                                <div style={{ flex: 1, maxWidth: "180px" }}>
                                    <Progress
                                        value={pct}
                                        color="success"
                                        style={{ height: "6px", borderRadius: "3px", backgroundColor: "#e8f5e9" }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "160px", textAlign: "right" }}>
                                <span style={{ fontSize: "0.85rem", fontWeight: 600, color: "var(--color-brand-primary)" }}>
                                    {line.amount > 0 ? formatCurrency(line.amount) : "—"}
                                </span>
                            </div>
                        </div>
                    );
                })}

                {/* TOTAL RECEITAS BRUTAS */}
                <div
                    className="d-flex align-items-center px-4 py-3 mb-2"
                    style={{ borderBottom: "2px solid rgba(72, 39, 18, 0.12)", background: "rgba(46, 125, 50, 0.06)" }}
                >
                    <div style={{ flex: 1, paddingLeft: "28px" }}>
                        <span className="fw-bold text-uppercase" style={{ fontSize: "0.85rem", color: "#2e7d32", fontFamily: "Outfit, sans-serif" }}>
                            Total Receita
                        </span>
                    </div>
                    <div style={{ width: "30%" }} />
                    <div style={{ width: "160px", textAlign: "right" }}>
                        <span className="fw-bold" style={{ fontSize: "1.05rem", color: "#2e7d32", fontFamily: "Outfit, sans-serif", fontWeight: 900 }}>
                            {formatCurrency(totals.totalIncome)}
                        </span>
                    </div>
                </div>

                {/* ═══ DESPESAS E CUSTOS ═══ */}
                <div
                    className="d-flex align-items-center px-4 py-3"
                    style={{ cursor: "pointer", borderBottom: "1px solid rgba(72, 39, 18, 0.08)", background: "rgba(198, 40, 40, 0.02)", transition: "background-color 0.2s" }}
                    onClick={() => setExpandedExpense(!expandedExpense)}
                >
                    <div style={{ flex: 1, display: "flex", alignItems: "center", gap: "8px" }}>
                        <i
                            className={`mdi mdi-minus-circle${expandedExpense ? "-outline" : ""}`}
                            style={{ color: "#c62828", fontSize: "1.1rem" }}
                        />
                        <span className="fw-bold text-uppercase" style={{ color: "#c62828", fontSize: "0.85rem", letterSpacing: "0.5px", fontFamily: "Outfit, sans-serif" }}>
                            Despesas, Taxas e Custos Operacionais
                        </span>
                    </div>
                    <div style={{ width: "30%" }} />
                    <div style={{ width: "160px" }} />
                </div>

                {expandedExpense && expense.map((line) => {
                    const pctOfExpense = totals.totalExpense > 0 ? (line.amount / totals.totalExpense * 100) : 0;
                    return (
                        <div
                            key={line.id}
                            className="d-flex align-items-center px-4 py-2.5"
                            style={{ borderBottom: "1px solid rgba(72, 39, 18, 0.06)", paddingLeft: "48px" }}
                        >
                            <div style={{ flex: 1, paddingLeft: "28px" }}>
                                <span style={{ fontSize: "0.85rem", color: "var(--color-brand-primary)", fontFamily: "Outfit, sans-serif", fontWeight: line.name.includes("Taxas") ? 600 : 400 }}>
                                    {line.name}
                                </span>
                            </div>
                            <div style={{ width: "30%", display: "flex", alignItems: "center", gap: "8px", justifyContent: "center" }}>
                                <span style={{ fontSize: "0.75rem", color: "#78909c", minWidth: "40px", textAlign: "right" }}>
                                    {pctOfExpense.toFixed(1)}%
                                </span>
                                <div style={{ flex: 1, maxWidth: "180px" }}>
                                    <Progress
                                        value={Math.min(pctOfExpense, 100)}
                                        color="danger"
                                        style={{ height: "6px", borderRadius: "3px", backgroundColor: "#ffebee" }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "160px", textAlign: "right" }}>
                                <span style={{ fontSize: "0.85rem", fontWeight: 600, color: "#c62828" }}>
                                    {line.amount > 0 ? formatCurrency(line.amount) : "—"}
                                </span>
                            </div>
                        </div>
                    );
                })}

                {/* TOTAL DESPESAS */}
                <div
                    className="d-flex align-items-center px-4 py-3"
                    style={{ borderBottom: "2px solid rgba(72, 39, 18, 0.12)", background: "rgba(198, 40, 40, 0.06)" }}
                >
                    <div style={{ flex: 1, paddingLeft: "28px" }}>
                        <span className="fw-bold text-uppercase" style={{ fontSize: "0.85rem", color: "#c62828", fontFamily: "Outfit, sans-serif" }}>
                            Custo Total Deduzido
                        </span>
                    </div>
                    <div style={{ width: "30%" }} />
                    <div style={{ width: "160px", textAlign: "right" }}>
                        <span className="fw-bold" style={{ fontSize: "1.05rem", color: "#c62828", fontFamily: "Outfit, sans-serif", fontWeight: 900 }}>
                            {formatCurrency(totals.totalExpense)}
                        </span>
                    </div>
                </div>

                {/* ═══ RESULTADO LÍQUIDO DO EXERCÍCIO ═══ */}
                <div
                    className="d-flex align-items-center px-4 py-3.5 mx-4 my-4"
                    style={{
                        borderRadius: "12px",
                        border: `2px solid ${resultIsPositive ? "#2e7d32" : "#c62828"}`,
                        background: resultIsPositive ? "rgba(46, 125, 50, 0.06)" : "rgba(198, 40, 40, 0.06)",
                        boxShadow: "0 4px 12px rgba(72, 39, 18, 0.05)"
                    }}
                >
                    <div style={{ flex: 1, display: "flex", alignItems: "center", gap: "12px" }}>
                        <span className="fw-bold text-uppercase" style={{
                            fontSize: "0.9rem",
                            color: "var(--color-brand-primary)",
                            fontFamily: "Outfit, sans-serif",
                            fontWeight: 900,
                            letterSpacing: "0.5px"
                        }}>
                            Lucro Líquido do Exercício
                        </span>
                        <Badge
                            className="text-white"
                            style={{
                                background: resultIsPositive ? "#2e7d32" : "#c62828",
                                color: "#ffffff",
                                border: "none",
                                fontWeight: 700,
                                fontSize: "0.75rem",
                                padding: "4px 10px",
                                borderRadius: "30px",
                                fontFamily: "Outfit, sans-serif"
                            }}
                        >
                            Margem Real: {totals.margin.toFixed(1)}%
                        </Badge>
                    </div>
                    <div style={{ width: "160px", textAlign: "right" }}>
                        <span className="fw-bold" style={{
                            fontSize: "1.35rem",
                            color: resultIsPositive ? "#2e7d32" : "#c62828",
                            fontFamily: "Outfit, sans-serif",
                            fontWeight: 900
                        }}>
                            {formatCurrency(totals.netResult)}
                        </span>
                    </div>
                </div>

            </CardBody>
        </Card>
    );
};

export default DRETable;
